const record = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const text = value => typeof value === 'string' && value.trim().length > 0;
const lesson = value => record(value) && Number.isInteger(value.number) && value.number >= 1 && text(value.title);
const lessons = value => Array.isArray(value) && value.length > 0 && value.every(lesson);
const sets = value => Array.isArray(value) && value.length > 0 && value.every(set =>
  record(set) && text(set.setCode) && text(set.title) && lessons(set.lessons));
export const isCurriculumStructure = value => record(value)
  && ['none', 'flatLessons', 'setsWithLessons'].includes(value.kind)
  && (value.lessons === undefined || lessons(value.lessons))
  && (value.sets === undefined || sets(value.sets))
  && (value.kind !== 'flatLessons' || lessons(value.lessons))
  && (value.kind !== 'setsWithLessons' || sets(value.sets));
export class CurriculumRequestContractError extends Error {
  constructor(detail) {
    super(`Invalid curriculum request: ${detail}`);
    this.name = 'CurriculumRequestContractError';
    this.code = 'INVALID_API_REQUEST';
  }
}
export const readCurriculumQuery = query => {
  if (!record(query)
    || ['activityTypeName', 'grade'].some(field => query[field] !== undefined && typeof query[field] !== 'string')
    || query.activityType !== undefined && query.activityType !== '' && (typeof query.activityType !== 'string' || !/^[a-f0-9]{24}$/i.test(query.activityType))) {
    throw new CurriculumRequestContractError('use scalar filters and an optional activity type ObjectId.');
  }
  return query;
};
export const readCurriculumIdentifier = id => {
  if (!(text(id) || Number.isInteger(id) && id > 0)) {
    throw new CurriculumRequestContractError('expected an identifier or grade key.');
  }
  return String(id).trim();
};
